<template>
  <div class="tasks row justify-content-center">
    <b-modal ref="removeConfirmation" id="removeConfirmation" title="Ta bort uppgift" @ok="removeAction" @cancel="removeCancel" close-title="Nej" ok-title="Ja">
        <span>Vill du ta bort uppgiften?</span>
    </b-modal>
    <b-modal ref="createTask" id="createTask" title="Ny uppgift" @hidden="resetEditor">
        <div slot="modal-footer" class="row fill justify-left">
            <div class="col-sm-6 justify-left">
                <b-form-fieldset
                    label="Max"
                    horizontal>
                    <b-form-input v-model="maxRecv" type="number"></b-form-input>
                </b-form-fieldset>
            </div>
            <div class="col-sm-6">
                <div class="float-right">
                    <b-button @click="resetEditor">Avbryt</b-button>
                    <b-button @click="create" variant="primary">Skapa</b-button>
                </div>
            </div>
        </div>
        <at-textarea :members="getAutocompleteList()" :avoid-emails="true">
            <textarea id="markdownEditor" class="editorMain" v-model="content"></textarea>
        </at-textarea>
        <button v-if="!this.deadline" class="btn btn-md btn-outline-success btn-block" type="submit" @click="setDeadline">Förfaller</button>
        <Datetime v-else class="form-control" type="datetime" monday-first auto-continue v-model="deadline"></Datetime>
    </b-modal>
    <div class="col-sm-9">
        <div class="row">
            <div class="col-sm-2">
                <b-button size="lg" v-b-modal.createTask variant="success">Skapa</b-button>
            </div>
            <div class="col-sm-2 prefix">
                <span>Arbetsyta:</span>
            </div>
            <div class="col-sm-4">
                <select class="form-control" v-model="selected">
                    <option value="Ingen">Alla</option>
                    <option v-for="workarea in workareas" v-bind:value="workarea">
                        {{ workarea.name }}
                    </option>
                </select>
            </div>
            <div class="col-sm-4">
                <div class="input-group">
                    <input v-model="searchinter" @keyup.enter="setSearchString()" type="text" class="form-control" placeholder="Sök">
                    <span class="input-group-btn"><button class="btn btn-secondary" @click="setSearchString()"><i class="material-icons icon">&#xE8B6;</i></button></span>
                </div>
            </div>
        </div>
        <div class="row task-row w-80" v-for="(task, index) in tasks">
            <Task :task="task" :index="index" v-on:remove="setRemoveTask({task, index})" v-on:send="sendTask(task)" :workarea="workarea"></Task>
        </div>
    </div>
    <div class="col-sm-3">
        <div class="filter-row">
            <span>Visar nu <b>{{ tasks !== null ? tasks.length : 0 }}</b> uppgifter</span>
        </div>
        <div class="filter-row">
            <h5>Delade</h5>
            <b-form-select v-model="shared" :options="sharedOptions">
            </b-form-select>
        </div>
        <div class="filter-row">
            <h5>Förfallna</h5>
            <b-form-select v-model="deadlineShow" :options="deadlineOptions" :stacked="true">
            </b-form-select>
        </div>
        <div class="filter-row">
            <h5>Ordning</h5>
            <b-button-group>
                <b-button :variant="orderKey === 'created_at' ? 'success' : 'secondary'" @click="reverseOrder('created_at')">Skapad <i v-if="order === 'desc' && orderKey === 'created_at'" class="material-icons icon align">&#xE5DB;</i><i v-if="order === 'asc' && orderKey === 'created_at'" class="material-icons icon align">&#xE5D8;</i></b-button>
                <b-button :variant="orderKey === 'updated_at' ? 'success' : 'secondary'" @click="reverseOrder('updated_at')">Uppdaterad <i v-if="order === 'desc' && orderKey === 'updated_at'" class="material-icons icon align">&#xE5DB;</i><i v-if="order === 'asc' && orderKey === 'updated_at'" class="material-icons icon align">&#xE5D8;</i></b-button>
                <b-button :variant="orderKey === 'deadline' ? 'success' : 'secondary'" @click="reverseOrder('deadline')">Förfaller <i v-if="order === 'desc' && orderKey === 'deadline'" class="material-icons icon align">&#xE5DB;</i><i v-if="order === 'asc' && orderKey === 'deadline'" class="material-icons icon align">&#xE5D8;</i></b-button>
            </b-button-group>
        </div>
        <div class="filter-row">
            <h5>Filter</h5>
            <table class="table table-bordered table-striped">
                <thead>
                    <tr>
                        <th>Status</th>
                        <th>Visa</th>
                    </tr>
                </thead>
                <tbody>
                    <tr><td>Öppen</td><td><input type="checkbox" value="1" v-model="statuses" v-on:change="filter"></td></tr>
                    <tr><td>Avslutad</td><td><input type="checkbox" value="2" v-model="statuses" v-on:change="filter"></td></tr>
                    <tr><td>Planerad</td><td><input type="checkbox" value="3" v-model="statuses" v-on:change="filter"></td></tr>
                    <tr><td>Pågående</td><td><input type="checkbox" value="4" v-model="statuses" v-on:change="filter"></td></tr>
                    <tr><td>Avvakta</td><td><input type="checkbox" value="5" v-model="statuses" v-on:change="filter"></td></tr>
                    <tr><td>Klar</td><td><input type="checkbox" value="6" v-model="statuses" v-on:change="filter"></td></tr>
                </tbody>
            </table>
        </div>
        <div class="filter-row">
            <button @click="selectFilter({tag: null, category: null})" class="btn btn-md btn-warning btn-block">Rensa filter</button>
            <ul class="filter filter-first">
                <li v-for="tag in filterList['']">
                    <a href="#" @click="selectFilter({tag: tag, category: null})">#{{ tag }}</a>
                </li>
            </ul>
            <ul class="filter">
                <li v-for="(tags, category) in filterList" v-if="category !== ''">
                    <a href="#" @click="selectFilter({tag: null, category: category})">+{{ category }}</a>
                    <ul class="subfilter" v-if="tags.length > 0">
                        <li v-for="tag in tags">
                            <a href="#" @click="selectFilter({tag: tag, category: category})">#{{ tag }}</a>
                        </li>
                    </ul>
                </li>
            </ul>
        </div>
    </div>
  </div>
</template>

<script src="table.js"></script>

<script>
import _ from 'lodash'
import { mapActions, mapMutations, mapGetters } from 'vuex'
import parser from '@/utils/parser'
import AtTextarea from '@/components/addins/AtTextarea'
import Task from '@/components/parts/Task'
import { Datetime } from 'vue-datetime'

export default {
    name: 'main',
    components: {
        AtTextarea,
        Task,
        Datetime
    },
    data () {
        return {
            content: '',
            selected: 'Ingen',
            search: '',
            removeTask: null,
            orderKey: 'created_at',
            order: 'asc',
            searchinter: '',
            selectedFilter: {},
            shared: 'all',
            maxRecv: 0,
            deadline: null,
            deadlineShow: 'all',
            sharedOptions: [{
                text: 'Alla uppgifter',
                value: 'all'
            }, {
                text: 'Inte delade',
                value: 'non'
            }, {
                text: 'Mottagna',
                value: 'received'
            }, {
                text: 'Skickade',
                value: 'sent'
            }, {
                text: 'Lästa',
                value: 'read'
            }, {
                text: 'Accepterade',
                value: 'accepted'
            }, {
                text: 'Avvisade',
                value: 'rejected'
            }, {
                text: 'Klara',
                value: 'done'
            }],
            deadlineOptions: [{
                text: 'Alla uppgifter',
                value: 'all'
            }, {
                text: 'Förfallna',
                value: 'due'
            }, {
                text: 'Inte förfallna',
                value: 'rest'
            }]
        }
    },
    computed: {
        tasks () {
            return this.$store.getters.getFilteredTasks(this.search, this.orderKey, this.order, this.selectedFilter, this.shared, this.favorites, this.deadlineShow)
        },
        filterList () {
            let tasks = this.$store.getters.getFilteredTasks(this.search, this.orderKey, this.order, {}, 'all', this.favorites, 'all')
            let list = {}

            _.each(tasks, task => {
                if (task.categories && task.categories.length > 0) {
                    _.each(task.categories, category => {
                        list[category] = _.union(list[category], task.tags)
                    })
                } else {
                    list[''] = _.union(list[''], task.tags)
                }
            })

            return list
        },
        workareas () {
            return this.$store.state.workarea.workareas
        },
        statuses () {
            return this.$store.state.filter.statuses
        },
        workarea () {
            return this.$store.state.filter.workarea
        },
        favorites () {
            return this.$store.state.favorites.favorites
        }
    },
    mounted () {
        // Update all tasks
        if (this.$store.state.task.syncing !== true) {
            this.list({offset: 0})
        }

        // Get the selected
        this.selected = this.workarea === null ? 'Ingen' : this.workarea
    },
    watch: {
        selected: function () {
            this.updateWorkarea(this.selected === 'Ingen' ? null : this.selected)
        }
    },
    methods: {
        ...mapActions({
            list: 'task_list',
            get: 'task_get',
            remove: 'task_delete',
            insert: 'task_post',
            select: 'task_select'
        }),
        ...mapMutations({
            updateStatuses: 'FILTER_SET_STATUSES',
            updateWorkarea: 'FILTER_SET_WORKAREA'
        }),
        ...mapGetters({
            getFriends: 'getFriendsList'
        }),
        create: function () {
            // Parse the task
            var task = parser.parse(this, this.content, this.workarea, this.maxRecv)

            // Empty the content
            this.content = ''

            // Set the deadline
            task.deadline = this.deadline

            // Create and insert the task
            this.insert(task)

            // Close the editor
            this.$refs.createTask.hide()
        },
        getAutocompleteList: function () {
            // Get both groups and friends
            let friend = this.getFriends()
            let groups = this.$store.state.group.groups

            // Add '@' infront of all group names and extract the names
            groups = _.map(groups, g => '@' + g.name)

            // Return the array
            return _.concat(friend, groups)
        },
        sendTask: function (task) {
            this.content = task.content
            this.$refs.createTask.show()
        },
        filter: function (event) {
            var status = parseInt(event.target.value)
            var remove = _.filter(this.statuses, elem => elem !== status)
            if (remove.length === this.statuses.length) {
                this.updateStatuses(_.concat(this.statuses, status))
            } else {
                this.updateStatuses(remove)
            }
        },
        removeAction: function () {
            this.remove(this.removeTask)
        },
        setRemoveTask: function ({task, index}) {
            this.removeTask = {task, index}
            this.$refs.removeConfirmation.show()
        },
        removeCancel: function () {
            this.removeTask = null
        },
        reverseOrder: function (orderKey) {
            this.orderKey = orderKey
            this.order = this.order === 'asc' ? 'desc' : 'asc'
        },
        selectFilter: function ({tag, category}) {
            this.selectedFilter = {tag, category}
        },
        resetEditor: function () {
            this.content = ''
            this.$refs.createTask.hide()
        },
        setSearchString: function () {
            this.search = this.searchinter
        },
        setDeadline: function () {
            this.deadline = new Date().toLocaleString()
        }
    }
}
</script>

<style lang="scss">
    .fill {
        width: 100%;
    }

    .favorite {
        background-color: inherit !important;
        border: none !important;
        color: black !important;
    }

    .favorited {
        color: gold !important;
    }

    .justify-left {
        padding-left: 0px !important;
    }

    .task-row {
        margin-top: 1rem;
    }

    .task-row div.card-header {
        padding-top: 0px;
        padding-bottom: 0px;
    }

    .received {
        .card-header, .card-footer {
            background-color: #f39c12;
            color: #ecf0f1;

            a.nav-link {
                color: #ecf0f1;
            }
        };
    }

    .workname a {
        color: black !important;
        background-color: white;
        border: 1px solid white;
        -webkit-border-radius: 5px;
        -moz-border-radius: 5px;
        border-radius: 5px;
    }

    .sent {
        .card-header, .card-footer {
            background-color: #1abc9c;
            color: #ecf0f1;

            a {
                color: #ecf0f1;
            }

            span {
                color: #ecf0f1;
            }
        };
    }

    .icon {
        font-size: 1.25rem;
        line-height: 1.25;
    }

    .align {
        vertical-align: bottom;
    }

    .datetime {
        font-weight: 500;
    }

    .task-header {
        .dropdown {
            margin-left: 1rem;
        }
    }

    .remove-button {
        padding: 0.1rem;

        button {
            .icon {
                font-size: 1.5rem;
            }
        }
    }

    .filter-row {
        margin-top: 1rem;
    }

    ul.filter-first {
        margin-top: 1rem;
    }

    .sentmsg {
        background-color: #3498db;
    }

    ul.filter {
        list-style-type: none;
        padding: 0.5rem;
        background: #27ae60;

        a {
            color: #ecf0f1;
        }

        li {
            margin: 0.5rem 0rem 0.5rem 0rem;
        }

        ul.subfilter {
            list-style-type: none;
            padding: 0;
            
            li {
                border-left: none;
                border-right: none;
                padding: 0.5rem;
                background: #27ae60;
                
                a {
                    color: #ecf0f1;
                }
            }
        }
    }

    textarea.editorMain {
        width: 29rem;
        height: 25rem;
        border: 1px solid #95a5a6;
    }

    .vdatetime {
        input {
            border: none;
        }
    }
</style>



// WEBPACK FOOTER //
// src/components/Main.vue